<template>
    <!-- 融资利息 -->
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="交易日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="交易日期"></el-date-picker>
                </div>
                <el-select class="search_select search_inputBox" v-model="params.title" placeholder="流水类目"
                    @visible-change="getSelectList('issuingInterestTitle')">
                    <el-option v-for="(list,index) in selectMap.issuingInterestTitle" :key="index" :value="list.id"
                        :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.status" placeholder="利息状态"
                    @visible-change="getSelectList('issuingInterestStatus')">
                    <el-option v-for="(list,index) in selectMap.issuingInterestStatus" :key="index" :value="list.id"
                        :label="list.name"></el-option>
                </el-select>
                <div class="reset fcolor" @click="resetSearch">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible,scene='issuing.interest.list';isGlobal=false;filter=filter;"></div>
                    <span class="excel_btn" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked" @click="openInterestPayment()">结息付款</el-button>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="issuing.interest.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @rowClick="rowClick"></tabletem>
            </div>
            <div class="totalCal">
                <div class="totalNumber">合计：</div>
                <div class="totalNumber">融资余额：{{totalObj.finance_balance}}</div>
                <div class="totalNumber">赎货金额：{{totalObj.redeem_amount}}</div>
                <div class="totalNumber">货款金额：{{totalObj.finance_amount}}</div>
                <div class="totalNumber"> 保证金：  {{totalObj.deposit}}</div>
                <div class="totalNumber">融资利息：{{totalObj.amount}}</div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- 新增付款单 dialog START -->
        <el-dialog v-dialog-drag title="结息付款" :visible.sync="dialogVisible" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="form_params" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="起息日：">
                        <el-date-picker v-model="form_params.start_time" type="date" disabled></el-date-picker>
                    </el-form-item>
                    <el-form-item label="结息日：">
                        <el-date-picker v-model="form_params.end_time" type="date" @change="openInterestPayment()"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="计息天数：">
                        <el-input v-model="form_params.days" disabled placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="利息金额：">
                        <el-input v-model="form_params.amount" disabled placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="服务商名称：">
                        <el-input v-model="form_params.issuing" disabled placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="付款日期：">
                        <el-date-picker v-model="form_params.trading_time" type="date" ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="付款方式：">
                        <el-select v-model="form_params.payment_type_id" placeholder="" @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="'add_form_payment_type_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="付款账户：">
                        <el-select v-model="form_params.account_id" placeholder="" @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="form_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="dialogVisible=!dialogVisible">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="interestPayment">确定</el-button>
            </div>
        </el-dialog>
        <!-- 融资提单详情 START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibles" class="eldialog eldialogC threeLabel no_print eldialogWidth" :modal="false" :title="'融资提单详情'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB dialogForm" :model="form_params_a" ref="saleorderA">
                    <div class="elFormBox">
                        <el-form-item  label="融资提单：" prop="customer_id">
                            <el-input v-model="form_params_a.order_sn" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox"> 
                        <el-form-item  label="开证公司：" prop="salesman_id">
                            <el-input v-model="form_params_a.issuing" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="融资类型：" prop="sales_time">
                            <el-input v-model="form_params_a.finance_type_text" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="代缴税金：" prop="sales_time">
                            <el-input v-model="form_params_a.agent_tax_status" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisibleA=!filterDialogVisibleA"></div>
                </el-form>
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <el-table :data="listDetail" :summary-method="getTableSummaries" ref="outBoundDetailTable" border show-summary stripe highlight-current-row size="mini" height="100%" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <template v-for="(item) in filterA">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.includes(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>0 ?item.width:80+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                        <template slot-scope="scope">
                                            <div v-if="item.field == 'sales_width_total'">
                                                <span @click="widthList = scope.row.sales_width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                                    {{ scope.row.sales_width_total }}
                                                </span>
                                            </div>
                                            <span v-else>
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                    </div>
                </div>
                <div class="totalCal">
                    <div class="totalName">合计：</div>
                    <div class="totalNumber">融资货值:{{form_params_a.finance_amount}}</div>  
                    <div class="totalNumber" v-if="form_params_a.agent_tax_status=='是'">代缴税金:{{form_params_a.agent_tax}}</div>      
                    <div class="totalNumber">融资费用：{{form_params_a.finance_fee}}</div>
                    <div class="totalNumber">融资总额:{{form_params_a.finance_amount_total}}</div>
                    <div class="totalNumber">总板尺：{{form_params_a.plate_ruler}}</div>
                    <div class="totalNumber">外币总额:{{form_params_a.foreign_currency_amount}}</div>
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson" v-if="form_params_a.creator_name">制单人：{{form_params_a.creator_name}}</div>
                </div>
                <div>

                </div>
                <div class="editBtnList clearfix">
                    <div class="editBtn">
                        <el-button class="funcPublicBtn" v-if="module.indexOf(',warehouse-doc-out-export,')!=-1" @click="exportExcel">导出</el-button>
                        <el-button class="funcPublicBtn" @click="dialogVisibles=!dialogVisibles">关闭</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->
        <!-- 赎货单详情 START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleB" class="eldialog eldialogC threeLabel no_print eldialogWidth" :modal="false" :title="'销售赎货单(单号：'+form_params_b.redeem_order_sn+')'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB dialogForm" :model="form_params_b" ref="saleorderA">
                    <div class="elFormBox">
                        <el-form-item  label="开证公司：" prop="customer_id">
                            <el-input v-model="form_params_b.issuing" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox"> 
                        <el-form-item  label="赎货日期：" prop="salesman_id">
                            <el-date-picker v-model="form_params_b.redeem_date" type="date" :readonly="true" placeholder="" size="mini" disabled></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="融资合同号：" prop="sales_time">
                            <el-input v-model="form_params_b.contract_no" disabled></el-input>
                        </el-form-item>
                       
                    </div>
                    <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisibleB=!filterDialogVisibleB"></div>
                </el-form>
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <el-table :data="listDetailB" :summary-method="getTableSummaries" ref="outBoundDetailTable" border show-summary stripe highlight-current-row size="mini" height="100%" @header-dragend="headDrogB">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <!-- <el-table-column type="selection" :selectable="checkSelectable" width="50"></el-table-column> -->
                                <template v-for="(item) in filterB">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.includes(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>0 ?item.width:80+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                        <template slot-scope="scope">
                                            <div v-if="item.field == 'sales_width_total'">
                                                <span @click="widthList = scope.row.sales_width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                                    {{ scope.row.sales_width_total }}
                                                </span>
                                            </div>
                                            <span v-else>
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                    </div>
                </div>
                <div class="totalCal">
                    <div class="totalName">合计：</div>
                    <div class="totalNumber">可发方数:{{form_params_b.property_cube}}m³</div>  
                    <div class="totalNumber">赎货单方数:{{form_params_b.redeem_cube}}m³</div>      
                    <div class="totalNumber">应赎方数:{{form_params_b.pay_redeem_cube}}m³</div>
                    <div class="totalNumber" v-if="form_params_b.pay_redeem_amount>0">应付金额: <span  style="color:red">{{form_params_b.pay_redeem_amount}}</span></div>  
                    <div class="totalNumber" v-if="form_params_b.real_pay_amount>0">实付金额:{{form_params_b.real_pay_amount}}</div>
                    <div class="totalNumber">应赎金额:{{form_params_b.real_redeem_amount}}</div>      
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson">销售人：{{form_params_b.salesman_name}}</div>
                    <!-- <div class="editPerson">打印时间：{{parseInt(new Date().getTime()/1000) | dateFormat_}}</div>-->
                </div>
                <div>

                </div>
                <div class="editBtnList clearfix">
                    <div class="editBtn">
                        <el-button class="funcPublicBtn" @click="dialogVisibleB=!dialogVisibleB">关闭</el-button>
                         <!-- <el-button class="funcPublicBtn funcPublicBtnChecked" @click="openaddDialogVisibleBack(2)">付款</el-button>  -->
                    </div>
                </div>
                
            </div>
        </el-dialog>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="issuing.interest.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 融资提单详情 START -->
        <filter-fields :tableData="filterA" :isGlobal="isGlobal" scene="pledge.order.info" :filterDialogVisible="filterDialogVisibleA" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisibleA = val;}"></filter-fields>
        <!-- 融资提单详情 END -->
         <!-- 赎货单 START -->
        <filter-fields :tableData="filterB" :isGlobal="isGlobal" scene="redeem.sales.column" :filterDialogVisible="filterDialogVisibleB" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisibleB = val;}"></filter-fields>
        <!-- 赎货单 END -->
    </div>
</template>
<style scoped lang="scss">
 .editBtnList{padding-top:10px;
    .editTax{float: left;}
    .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
    .editTaxinput{float: left;width:100px;}
    .editBtn{float: right;}
    .editLeft{float: left;}
}
.editPerson{padding-top: 10px;}
</style>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    const initDetailItem = {
       
    };
    const initDetailList = [initDetailItem];
    export default {
        components:{
            pagination,
            tabletem
        },
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                start_time: "",
                end_time: "",
                params:{
                    start_time: "",
                    end_time: "",
                    issuing_id:'',
                    title:'',
                    status:'',
                    per_page: 50,
                    page:1
                },
                totalObj:{},
                last_page: 1,
                current_page: 1,
                total: 0,
                list : [],
                proList:[],
                cityList:[],
                searchCityList:[],
                selectMap:{
                    issuingInterestStatus:[],
                    issuingInterestTitle:[],
                    paymentType:[],
                    paymentType:[],
                },
                // dialog
                dialogVisible : false,
                fields:"",
                filter:"",
                filterA: [],
                filterB: [],
                filterDialogVisible:false,
                filterDialogVisibleA:false,
                filterDialogVisibleB:false,
                isGlobal:false,
                form_params : {
                    start_time:'',
                    end_time:'',
                    amount:'',
                    issuing:'',
                    days:'',
                    trading_time:new Date(),
                },
                listDetail: this.$cloneJson(initDetailList),
                dialogVisibleB:false,
                form_params_b:{},
                issuing_balance:{},
                listDetailB:[],
                rules: {
                    name : [ { required: true, message: '请输入供应商', trigger: 'blur' } ],
                    
                },
               tableCol:[	
                    {colName:"开证公司",colKey:"issuing",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"融资余额",colKey:"finance_balance",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"流水类目",colKey:"title",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"日期",colKey:"bill_date",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"赎货金额",colKey:"redeem_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"赎货单号",colKey:"redeem_order_sn",colWidth:100,isSetWidth:true,isCanClick:true,isShow:true},
                    {colName:"货款金额",colKey:"finance_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"保证金",colKey:"deposit",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"融资提单号",colKey:"finance_order_sn",colWidth:80,isSetWidth:true,isCanRongClick:true,isColor:true,},
                    {colName:"利息",colKey:"amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"状态",colKey:"status_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                ],
                dialogVisibles:false,
                form_params_a:{},
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            if(sessionStorage.DEMU_ERP_FINANCE_INTEREST_ID){
                this.id=sessionStorage.DEMU_ERP_FINANCE_INTEREST_ID;
                this.params.issuing_id=sessionStorage.DEMU_ERP_FINANCE_INTEREST_ID;
                sessionStorage.removeItem("DEMU_ERP_FINANCE_INTEREST_ID")
            }
            
            this.getList();
            this.getSelectList("issuingInterestStatus")
            this.getSelectList("issuingInterestTitle")
            this.getSelectList("paymentType")
            this.getSelectList("account")
        },
        methods:{
            headDrog(newWidth, oldWidth, column) {
                this.filterA.forEach((item) => {
                    if (column.property == item.colKey) {
                        item.colWidth = newWidth;
                    }
                });
                let obj = {};
                obj.width = parseInt(newWidth);
                obj.name = column.property;
                let emit = ("changeHeadWidth" + this.scene).replace(/\./g, "");
                bus.$emit(emit, obj);
            },
            headDrogB(newWidth, oldWidth, column) {
                this.filterB.forEach((item) => {
                    if (column.property == item.colKey) {
                        item.colWidth = newWidth;
                    }
                });
                let obj = {};
                obj.width = parseInt(newWidth);
                obj.name = column.property;
                let emit = ("changeHeadWidth" + this.scene).replace(/\./g, "");
                bus.$emit(emit, obj);
            },
            filterConfirm(){
                if(this.isGlobal){
                    this.getBillColumn()
                }else{
                    this.getList()
                }
            },
            getBillColumn(){
                if(this.isGlobal){
                    this.filterA = [];
                    this.filterB = [];
                    this.postFunc("/erp/company.column.data",{scene:this.scene},response=>{
                        this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                        this.filterA = response.data.data.columns;
                        this.filterB = response.data.data.columns;
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }else{
                    this.filter =[]
                    this.postFunc("/erp/company.column.data",{scene:'issuing.interest.list'},response=>{
                        this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                        this.filter = response.data.data.columns;
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }
            },
            exportExcelBill(){
                this.$exportExecl("erp/issuing.interest.export","融资利息",this.params)
            },
            getSelectList(target){
                let obj = new Object();
                if(target=="issuingInterestStatus"||target=="issuingInterestTitle"){
                    obj.issuing_id = this.id;
                }
                this.$getSelectList(target,obj).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },     
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.tableLoading = true;
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                this.$postColumnList("/erp/issuing.interest.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.data.last_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.list=res.data.data.data.data;
                    this.totalObj=res.data.data.total;
                    this.list.forEach((item,ind)=>{
                        if(item.bill_date==0){
                            this.list[ind].bill_date = "";
                        }else{
                            this.list[ind].bill_date = this.formatTime(item.bill_date+"000")
                        }
                        item.baseColor = "";
                        if(item.status==2){
                            item.baseColor="#FF0000";
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";

                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            
            resetSearch(){
                this.start_time='';
                this.end_time='';
                this.params={ start_time: "",end_time: "",issuing_id:this.id,title:'',status:'',per_page: 50,page:1}
                this.getList()
            },
            rowClick(obj){
                if(obj.name =='finance_order_sn'){
                    this.scene = 'pledge.order.info';
                    this.isGlobal = true;
                    this.getBillColumn();
                    this.dialogVisibles = true;
                    this.postFunc('/erp/pledge.order.info',{id:obj.row.finance_order_id},res=>{
                        this.form_params_a = res.data.data.info;
                        this.form_params_a.agent_tax_status=this.form_params_a.agent_tax_status ==1?'是':'否';
                        this.listDetail = res.data.data.details;
                    })
                }else if(obj.name =='redeem_order_sn'){
                    this.scene = 'redeem.sales.column';
                    this.isGlobal = true;
                    this.getBillColumn();
                    this.dialogVisibleB = true;
                    this.postFunc('/erp/redeem.order.info',{id:obj.row.redeem_order_id},res=>{
                        this.form_params_b = res.data.data;
                        this.form_params_b.redeem_date = this.formatTime(res.data.data.redeem_date+"000");
                        this.issuing_balance = this.form_params_b.issuing_balance;
                        this.listDetailB = this.form_params_b.details;
                    })
                }
            },
            getTableSummaries(params) {
                return this.$setSummaryFields(params, {
                    original_cube:4,
                    purchase_amount:2,
                    redeem_amount:2,
                },total=>{
                });
            },
            //打开结息付款
            openInterestPayment(){
                let obj = new Object();
                obj.issuing_id = this.id;
                obj.start_time = this.form_params.start_time?this.formatTimeZero(this.form_params.start_time):'';
                obj.end_time = this.form_params.end_time?this.formatTimeZero(this.form_params.end_time):'';
                this.postFuncLoading("/erp/issuing.interest.payinfo",obj,res=>{
                    let data = res.data.data;
                    this.form_params.start_time = this.formatTime(data.start_time+"000");
                    this.form_params.end_time = this.formatTime(data.end_time+"000");
                    this.form_params.amount = data.amount;
                    this.form_params.issuing = data.issuing;
                    this.form_params.days = data.days;
                    this.form_params.trading_time = new Date();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
                this.dialogVisible=true;
            },
            interestPayment(){
                let time_a = this.form_params.start_time;
                let time_b = this.form_params.end_time;
                let time_c = this.form_params.trading_time;
                this.form_params.start_time =this.formatTimeZero(this.form_params.start_time)
                this.form_params.end_time =this.formatTimeZero(this.form_params.end_time)
                this.form_params.trading_time =this.formatTimeZero(this.form_params.trading_time)
                this.form_params.issuing_id = this.id;
                this.postFuncLoading("/erp/issuing.interest.payment",this.form_params,()=>{
                    this.tip("结息付款成功","success");
                    this.resetSearch();
                    this.form_params = this.resetJson(this.form_params)
                    this.dialogVisible=false;
                },error=>{
                    this.form_params.start_time =time_a
                    this.form_params.end_time =time_b
                    this.form_params.trading_time =time_c
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            //导出 created by xiong
            exportExcel(){
                this.$exportExecl("/erp/pledge.order.info.export","出库单",{id:this.form_params.id})
            }
        },
        watch:{
            dialogVisible:function(val){
                if(!val){
                    this.form_params = this.resetJson(this.form_params)
                }
            },
            dialogVisibles:function(val){
                if(!val){
                    this.form_params_a = this.resetJson(this.form_params_a)
                }
            },
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            }
        }
    }
</script>
